import React, { useState, useEffect } from "react";

import Dashboard from "./Dashboard";
import DocumentsValidated from "./DocumentsValidated";
import DocumentsInProgress from "./DocumentsInProgress";
import Preferences from "./Preferences";
import { useParams } from "react-router-dom"
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Form } from 'react-bootstrap';
import getDocument from '../../../api/getDocument';
import { Modal, Button, InputGroup, Input, ModalHeader, ModalBody, ModalFooter, InputGroupAddon, InputGroupText } from 'reactstrap'
import { data } from "jquery";
import { Input as AntdInput } from 'antd';

import { useSelector } from 'react-redux';
import axios from 'axios'



let Data = [
  {
    name: "Template 1",
    created: "Admin",
    category: "Template",
    price: "70.00",
    type: "website",
    email: "test@gmail.com",
    date: "2022-03-11"
  },
  {
    name: "Template 1",
    created: "Admin",
    category: "Template",
    price: "70.00",
    type: "website",
    email: "test@gmail.com",
    date: "2022-03-11"
  },

]

const Form5 = () => {
  const containerStyle = {
    border: "2px solid gray",
    maxHeight: "auto",
    // flex: 1,
    height: "auto",
    overflowY: `hidden`,
    padding: "20px",
    borderRadius: "5px",
    margin: "0px 7px"

  };
  const containerStyle2 = {
    border: "2px solid gray",
    maxHeight: "auto",
    // flex: 1,
    height: "auto",
    overflowX: `hidden`,
    padding: "20px",
    borderRadius: "5px",
    margin: "0px 7px"

  };

  const [DocData, setDocData] = useState("")
  const [DocData2, setDocData2] = useState({})
  const mappableDocument = Object.entries(DocData2).filter(([key, val]) => key !== "_id");
  const immutableCols = ["document_status", "datetime_insertion", "created_by", "last_modification_date", "modified_by", "final_storage_location", "image_name", "recycle"]
  const selectedProject = useSelector(state => state.selectedProject);

  function encode(input) {
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    while (i < input.length) {
      chr1 = input[i++];
      chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index 
      chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output += keyStr.charAt(enc1) + keyStr.charAt(enc2) +
        keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }
    return output;
  }
  useEffect(() => {
    axios.get(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/document/${window.location.pathname.split("/")[3]}/recycle`, {
      headers: {
        // 'Accept': 'application/pdf',
      },
      responseType: 'arraybuffer',
    }).then(res => {
      // console.log("res", res);
      var bytes = new Uint8Array(res.data);

      setDocData('data:image/png;base64,' + encode(bytes))
    })

    async function fetchValidateDocument() {
      var validateDocuments = await getDocument(selectedProject?.name, window.location.pathname.split("/")[2], window.location.pathname.split("/")[3]);
      setDocData2(validateDocuments?.data?.data[0])
    }
    fetchValidateDocument();

  }, [])


  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setformData] = useState({})
  const [data, setdata] = useState(Data)

  const history = useHistory()

  const onChange = (e) => {
    const { name, value } = e.target
    setformData({
      ...formData,
      [name]: value,
    });
  }

  const add = () => {
    Data.push(formData)
    // let dummy = data
    // dummy = [...dummy, formData]
    // setdata(data)
    handleAddClose()
  }



  const handleAddOpen = () => setShowAddModal(true);
  const handleAddClose = () => setShowAddModal(false);



  return (<>
    <div className="h-full  row">





      <div className="col-md-6 m-0">
        <h4 className="border-0 m-0 mb-3 text-center"> Parsed Document</h4>
        <div className="my-3 h-70" style={containerStyle2}>
          {/* <img src={DocData2} /> */}
          <InputGroupContainer>
            {mappableDocument.map(([key, value], i) => <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText
                  style={{
                    fontSize: immutableCols.includes(key) ? "12px" : "",
                    padding: immutableCols.includes(key) ? "6px" : "",
                    background: !immutableCols.includes(key) ? "rgb(63, 98, 116)" : "",
                    color: !immutableCols.includes(key) ? "#fff" : "",
                    borderColor: !immutableCols.includes(key) ? "rgb(63, 98, 116)" : ""
                  }}>
                  {key}
                </InputGroupText>
              </InputGroupAddon>
              <Input style={{ fontSize: immutableCols.includes(key) ? "12px" : "", padding: immutableCols.includes(key) ? "6px" : "" }} onChange={(e) => updateData(key, e.target.value)} disabled defaultValue={value} />
            </InputGroup>)}
          </InputGroupContainer>
        </div>

      </div>
      <div className="col-md-6 m-0" >
        <h4 className="border-0 m-0 mb-3 text-center">Recycled Document</h4>
        <div className="my-3 h-70" style={containerStyle}>
          <img src={DocData} />
        </div>
        <div className='dropdown-wrap-outer'>
          <div className='dropdown-wrap mr-2'>
            <div><label className='btn btn-secondary' htmlFor="dropdown-box-input" data-toggle="dropdown-box-outer" onClick={() => history.push(`/form/${window.location.pathname.split("/")[2]}/documents`)}>Finish</label></div>
          </div>
        </div>
      </div>
    </div>

  </>
  );
};

const InputGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`


export default Form5;
